var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryInprogress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.848,
    height: 27.588,
    viewBox: "0 0 35.848 27.588",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "van_inprogress",
    transform: "translate(-1.91 -5.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8584",
    "data-name": "Path 8584",
    d: "M24.913,5.5H3.07A1.138,1.138,0,0,0,1.92,6.65v13.8A1.146,1.146,0,0,0,3.07,21.6H24.913a1.153,1.153,0,0,0,1.15-1.15V6.652a1.146,1.146,0,0,0-1.15-1.15Z",
    transform: "translate(0.001)",
    fill: "#dc3a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8585",
    "data-name": "Path 8585",
    d: "M1.91,24.979a1.153,1.153,0,0,0,1.15,1.15H4.3a5.792,5.792,0,0,1,4.921-4.6H3.071a3.249,3.249,0,0,1-1.161-.207Z",
    transform: "translate(0 2.368)",
    fill: "#dc3a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8586",
    "data-name": "Path 8586",
    d: "M34.035,27.748h1.426a1.153,1.153,0,0,0,1.15-1.15V16.527c0-1.805-4.4-6.024-6.817-6.024H27.218v9.2a3.459,3.459,0,0,1-3.449,3.449H9.57a5.791,5.791,0,0,1,4.921,4.6H22.7a5.778,5.778,0,0,1,11.336,0ZM29.1,13.331c5.886-.287,5.645,5.794,5.645,5.794H29.1Z",
    transform: "translate(1.146 0.748)",
    fill: "#dc3a1a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_169",
    "data-name": "Ellipse 169",
    cx: 3.472,
    cy: 3.472,
    r: 3.472,
    transform: "translate(26.037 26.144)",
    fill: "#dc3a1a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_170",
    "data-name": "Ellipse 170",
    cx: 3.472,
    cy: 3.472,
    r: 3.472,
    transform: "translate(6.493 26.144)",
    fill: "#dc3a1a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryInprogress);
export default __webpack_public_path__ + "static/media/delivery_inprogress.ffa0204292a92c02d68b6bce986e466c.svg";
export { ForwardRef as ReactComponent };